import { Link } from 'react-router-dom';
import { latestComics } from '@/mocks/home';

export default function LatestSection() {
  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <h2 className="font-heading text-3xl md:text-4xl text-foreground-950 text-center mb-12">
          📖 最新更新
        </h2>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-5 md:gap-6">
          {latestComics.map((comic, index) => (
            <Link
              key={comic.id}
              to="/category/all"
              className="group bg-background-50 rounded-xl overflow-hidden border border-background-200/70 hover:border-primary-200 cursor-pointer transition-all duration-300 hover:-translate-y-1"
            >
              <div className="relative" style={{ aspectRatio: '3/4' }}>
                <img
                  src={comic.coverImage}
                  alt={comic.title}
                  title={`${comic.title} - 最新韩漫更新`}
                  className="w-full h-full object-cover object-top"
                />
                {index === 0 && (
                  <div className="absolute top-3 left-3 bg-accent-500 text-white text-xs font-bold px-2.5 py-1 rounded-full">
                    新作
                  </div>
                )}
              </div>

              <div className="p-4">
                <h3 className="text-sm md:text-base font-medium text-foreground-900 group-hover:text-primary-600 transition-colors truncate">
                  {comic.title}
                </h3>
                <p className="text-xs text-foreground-500 mt-1.5">{comic.latestChapter}</p>
                <div className="flex items-center gap-2 mt-2">
                  <span className="text-xs text-foreground-400">{comic.category}</span>
                  <span className="text-xs text-foreground-300">·</span>
                  <span className="text-xs flex items-center gap-0.5 text-foreground-400">
                    <span className="w-3 h-3 flex items-center justify-center"><i className="ri-star-fill text-yellow-400 text-xs"></i></span>
                    {comic.rating}
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>

        <div className="text-center mt-10">
          <Link
            to="/category/romance"
            className="inline-flex items-center gap-2 px-6 py-2.5 text-sm font-medium text-primary-600 hover:text-primary-700 rounded-full border border-primary-300 hover:border-primary-400 cursor-pointer transition-colors whitespace-nowrap"
          >
            查看更多更新 <span className="w-4 h-4 flex items-center justify-center"><i className="ri-arrow-right-line"></i></span>
          </Link>
        </div>
      </div>
    </section>
  );
}